import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export const DIRECTOR_EMAIL = process.env.REACT_APP_DIRECTOR_EMAIL || '';

export const COMPETENCIES = [
  { id: 'pain',         label: 'Pain Management',       color: '#2D6A8A', min: 30 },
  { id: 'opioid',       label: 'Opioid Conversion',      color: '#3A7D6B', min: 15 },
  { id: 'methadone',    label: 'Methadone Use',          color: '#6B4D8A', min: 5  },
  { id: 'ketamine',     label: 'Ketamine Use',           color: '#8A4D5A', min: 3  },
  { id: 'symptoms',     label: 'Symptom Management',     color: '#5A6B8A', min: 20 },
  { id: 'goals',        label: 'Code Status and Goals of Care', color: '#3A6B4D', min: 20 },
  { id: 'family',        label: 'Family Meeting',               color: '#4D7A5A', min: 15 },
  { id: 'communication',label: 'Communication',                 color: '#8A6B3A', min: 15 },
  { id: 'conflict',     label: 'Conflict Resolution',    color: '#8A5A3A', min: 5  },
  { id: 'spiritual',    label: 'Spiritual Assessment',   color: '#4D5A8A', min: 10 },
  { id: 'prognosis',    label: 'Prognosis Disclosure',   color: '#3A5A6B', min: 10 },
  { id: 'sedation',     label: 'Palliative Sedation',    color: '#5A3A8A', min: 3  },
  { id: 'bereavement',  label: 'Grief & Bereavement',    color: '#3A6B6B', min: 8  },
  { id: 'bleeding',     label: 'Palliative Care Emergencies', color: '#8A3A3A', min: 5  },
  { id: 'eol',          label: 'End-of-Life Care',       color: '#5A4A6B', min: 10 },
];

export const SETTINGS = [
  'Emergency Room',
  'Home Care Setting',
  'ICU',
  'Inpatient Consult',
  'Inpatient Hospice',
  'Outpatient Clinic',
  'Pain Clinic',
];

export const FACULTY_LIST = [
  'Dr. Omar Shamieh',
  'Dr. Fadi Abu-Farsakh',
  'Dr. Mahmoud Abu-Nasser',
  'Dr. Mohammad AlNemer',
  'Dr. Majd Awwad',
  'Dr. Emad Abu-Zakyah',
  'Dr. Lina AlHasasneh',
];

export const SUPERVISION_LEVELS = [
  'Observed Only', 'Assisted', 'Performed with Supervision', 'Performed Independently',
];

export const MILESTONE_LEVELS = [
  { n: 1, label: 'Novice',     desc: 'Requires step-by-step guidance' },
  { n: 2, label: 'Developing', desc: 'Performs with prompting' },
  { n: 3, label: 'Competent',  desc: 'Performs with occasional guidance' },
  { n: 4, label: 'Proficient', desc: 'Performs independently' },
  { n: 5, label: 'Expert',     desc: 'Teaches and leads others' },
];

export const APPROVAL_STATUSES = {
  pending:               { label: 'Pending Review',                color: '#C4A97C', bg: '#FFF8EE', border: '#F4DFA8' },
  approved:              { label: 'Approved',                      color: '#1E5C40', bg: '#F0FFF6', border: '#A8DCC0' },
  approved_with_comments:{ label: 'Approved with Comments',        color: '#2D6A8A', bg: '#EEF5FB', border: '#A8C8DC' },
  rejected:              { label: 'Rejected — Does Not Meet Level',color: '#8A2D2D', bg: '#FFF0F0', border: '#F4A8A8' },
};

export const REFLECTION_PROMPTS = [
  'What would you do differently next time?',
  'What was the most challenging aspect of this case?',
  'How did team dynamics influence the outcome?',
  'What did you learn about your own communication style?',
  'How did patient/family values shape your decision-making?',
  'What evidence or guidelines informed your management?',
  'How did you manage your own emotional response?',
];
